import React, { Component } from 'react';
import './App.css';


class Drawer extends Component {
	

  render() {
  	var currentImg=this.props.imgpath+this.props.imgsrc;

    return (
    	<div className="drawer">
			<img src={require(`${currentImg}`)} className="GridImg" alt="test"/>
		</div>

    );
  }
}

export default Drawer;


// WEBPACK FOOTER //
// ./src/Drawer.js